export default __webpack_public_path__ + "static/SiemensProgress-Bol-master-d1d94cd46958032fcde56bafe90e754b.woff";